var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-closed_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.98 11.02a.496.496 0 0 0 .707 0L3.64 9.067l.033-.033 1.19-1.19a2.167 2.167 0 0 0 2.982-2.982l1.199-1.198.012-.012 1.965-1.965a.5.5 0 1 0-.708-.707L8.619 2.675A5.36 5.36 0 0 0 6 2C3.331 2 1.706 3.86.975 4.97a1.87 1.87 0 0 0 0 2.06 7.5 7.5 0 0 0 1.56 1.728L.98 10.313a.5.5 0 0 0 0 .707m2.267-2.974.909-.909a2.167 2.167 0 0 1 2.982-2.982l.737-.737a4.4 4.4 0 0 0-1.874-.417C3.8 3 2.43 4.58 1.81 5.52a.88.88 0 0 0-.001.959 6.5 6.5 0 0 0 1.437 1.566M4.86 9.88C5.23 9.959 5.613 10 6 10c2.669 0 4.294-1.86 5.025-2.97a1.87 1.87 0 0 0 0-2.06 8 8 0 0 0-.693-.904.5.5 0 0 0-.747.665q.329.37.606.79c.19.286.19.672 0 .959C9.57 7.42 8.2 9 6 9a4.4 4.4 0 0 1-.93-.097.501.501 0 0 0-.21.978",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-closed_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgEyeClosed;